import { actionTypes } from 'logger';
import goldCombo from './images/gold-combo.svg';
import ptDegustation from './images/pt-degustation.svg';
import auProduction from './images/au-production.svg';
import silver from './images/silver.svg';

export const banners = [
  {
    img: goldCombo,
    link: 'https://jewelry.krastsvetmet.ru/catalog/products',
    target: '_self',
    eventName: actionTypes.BANNER_GOLD_COMBO,
  },
  {
    img: silver,
    link: 'https://jewelry.krastsvetmet.ru/catalog/products/2818-serebro-925',
    target: '_self',
    eventName: actionTypes.BANNER_SILVER_BET,
  },
  {
    img: auProduction,
    link: 'https://jewelry.krastsvetmet.ru/catalog/products',
    target: '_self',
    eventName: actionTypes.BANNER_ACCELERATED_PROD,
  },
  {
    img: ptDegustation,
    link: 'https://jewelry.krastsvetmet.ru/catalog/products/2807-platina-950',
    target: '_self',
    eventName: actionTypes.BANNER_PT_DEGUSTATION,
  },
];

export const ActiveBannerPathsEnum = {
  Catalog: 'catalog',
  PersonalOrders: 'personal/orders',
} as const;

export const ACTIVE_BANNERS_PATHS = Object.values(ActiveBannerPathsEnum);

export const ExcludeChannels = {
  KeyChannel: 'Ключевой канал',
  NearExport: 'Ближний экспорт',
  FarExport: 'Дальний экспорт',
} as const;

export const EXCLUDE_CHANNELS = Object.values(ExcludeChannels);
